import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  timeout: 20000,
});

// Inject the JWT token from localStorage on every request so authenticated
// endpoints (like /recommendations/today which masks VIP fields when not
// logged in) receive the auth header even though axios.create() doesn't
// inherit axios.defaults.headers.common.
client.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("np_token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {}
  return config;
});

export const fetchLotteries = async () => {
  const { data } = await client.get("/lotteries");
  return data;
};

export const fetchTodayRecommendations = async () => {
  const { data } = await client.get("/recommendations/today");
  return data;
};

export const fetchTodayResults = async () => {
  const { data } = await client.get("/results/today");
  return data;
};

export default client;
